module.exports = __webpack_public_path__ + "assets/img/dark-panel.3d2f3c81.png";